import { useEventCallback } from '@mui/material';
import type { GetIssueResponseDto } from '@issuemanager/api-client';
import {
  ContainerPopper,
  ExtendedGridColumnHeaderProps,
  FakeDropdownBox,
  IssueMultipleSelector,
  useDataGridContext,
} from '@issuemanager/apps/client/components';

export function IssueGridIssueFilter(params: ExtendedGridColumnHeaderProps) {
  const context = useDataGridContext();
  const value: GetIssueResponseDto[] = context.filterModel[params.field] ?? [];

  const handleChange = useEventCallback((value) => {
    context.setFilterModel((prevState) => ({
      ...prevState,
      [params.field]: value,
    }));
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length > 0 ? value.map((c) => c.code).join(', ') : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <IssueMultipleSelector
          open
          value={value}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
